const initailState = {
  speciesLookupArray: [],
};

const SodReducer = (state = initailState, action) => {
  switch (action.type) {
    case "Load_Species_Lookups":
      return {
        ...state,
        speciesLookupArray: action.payload,
      };
    default:
      return state;
  }
};
export default SodReducer;
